package com.milta.feature.subscription.data.remote.dto

import com.milta.feature.subscription.domain.entity.SubscriptionPlan
import com.milta.feature.subscription.domain.entity.SubscriptionPlanInfo
import kotlinx.serialization.Serializable

@Serializable
data class SubscriptionPlanInfoDto(
    val plan: String,
    val storeProductId: String,
    val price: Double,
    // MIL-64 — tax-exclusive (HT) price; `price` above remains the tax-inclusive (TTC) amount.
    // Defaults to 0.0 so an older backend response (before this field existed) still deserializes.
    val priceExclTax: Double = 0.0,
    val currency: String,
    val billingPeriod: String,
)

fun SubscriptionPlanInfoDto.toDomain() = SubscriptionPlanInfo(
    plan = if (plan == "Organisation") SubscriptionPlan.Organisation else SubscriptionPlan.Driver,
    storeProductId = storeProductId,
    price = price,
    priceExclTax = priceExclTax,
    currency = currency,
    billingPeriod = billingPeriod,
)
